<div class="d-flex align-items-center">
  <ng-container *ngIf="dprDetails">
    <div class="headerTitle" data-testId="dpr-details-id-date">
      {{ dprDetails.dprDateTime | toUtcDateTime : dprDetailsTimeFormat}} - #{{dprDetails.dprDisplayId | dprTitle}}
    </div>

    <ng-template
      *ngTemplateOutlet="dprDetails.firstWarning >= 0 ? incompleteStatusTemplate : completeStatusTemplate"
    ></ng-template>
    <ng-template #completeStatusTemplate>
      <app-chip
        class="ml-auto ml-sm-2"
        icon="check"
        dataTestId="complete-status"
        [label]="isHandset | responsiveLabel : 'Complete'"
        color="success"
      ></app-chip>
    </ng-template>
    <ng-template #incompleteStatusTemplate>
      <app-chip
        class="ml-auto ml-sm-2"
        [matTooltip]="dprDetails | warningTooltip: customNames : 'firstWarning' : 'warningStatusTab'"
        dataTestId="incomplete-status"
        [icon]="dprDetails | warningIcon : 'firstWarning'"
        [label]="isHandset | responsiveLabel : 'Incomplete'"
        color="wip"
      ></app-chip>
    </ng-template>

    <app-chip
      *ngIf="dprDetails?.lockedDate"
      class="ml-2"
      icon="lock"
      dataTestId="lock-date"
      [label]="isHandset | responsiveLabel : (dprLockedLabel | stringReplace : dynamicTextPlaceholder : (dprDetails?.lockedDate | toUtcDateTime | date : dprLockDateFormat))"
    ></app-chip>

    <app-chip
      class="ml-2"
      icon="autorenew"
      dataTestId="revision"
      [label]="isHandset | responsiveLabel : (dprRevisionLabel | stringReplace : dynamicTextPlaceholder : dprDetails.revision) : dprDetails.revision.toString()"
    ></app-chip>
  </ng-container>
</div>
